import React from 'react';
import {
	Grid,
	TextField,
	Box,
	Typography,
} from '@mui/material';
import { Expense } from '../../gql/graphql';

interface AdvancedTabProps {
	expenseData: Partial<Expense>;
	updateExpenseData: (updates: Partial<Expense>) => void;
}

function AdvancedTab({ expenseData, updateExpenseData }: AdvancedTabProps) {
	return (
		<Box>
			<Typography variant="h6" gutterBottom>
				Advanced Settings
			</Typography>
			<Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
				Additional expense information and metadata
			</Typography>

			<Grid container spacing={3}>
				{/* Expense ID */}
				<Grid item xs={12}>
					<TextField
						fullWidth
						label="Expense ID"
						name="_id"
						value={expenseData._id || 'Auto-generated after save'}
						disabled
						helperText="Unique identifier for this expense"
					/>
				</Grid>

				{/* Future Custom Fields */}
				<Grid item xs={12}>
					<Box sx={{ p: 2, bgcolor: 'grey.100', borderRadius: 1 }}>
						<Typography variant="body2" color="text.secondary">
							Additional custom fields such as payment method, vendor information, receipt attachments, and expense categories can be added here in future updates.
						</Typography>
					</Box>
				</Grid>
			</Grid>
		</Box>
	);
}

export default AdvancedTab;
